module.exports = __webpack_public_path__ + "static/media/cartao-verso.76281fb2.svg";